export const PROXY_HEADER_IMAGE_ROUTE = '/player/proxy/header_image';
export const PROXY_HEADER_IMAGE = 'PROXY_HEADER_IMAGE';
export const PROXY_HEADER_IMAGE_SUCCESS = 'PROXY_HEADER_IMAGE_SUCCESS';